module.exports = __webpack_public_path__ + "img/brachet.91e5d36a.png";